function Toggle(element: HTMLElement) {
  const toggle = element.querySelector('.toggle-items');

  if (toggle) {
    const showMore = toggle.getAttribute('data-label-more');
    const showLess = toggle.getAttribute('data-label-less');
    const contentElement = element.querySelector('.content');
    const secondaryElementContainer = element.querySelector('.secondary-elements-container');
    const secondaryElementChildren = secondaryElementContainer?.children;
    const clonedELements = secondaryElementChildren ? [...secondaryElementChildren] : [];

    // eslint-disable-next-line no-inner-declarations
    function show() {
      clonedELements.forEach((element) => element.classList.add('secondary-element'));
      contentElement.append(...clonedELements);

      toggle.textContent = showLess;
    }

    // eslint-disable-next-line no-inner-declarations
    function hide() {
      [...contentElement.children].forEach((element) => {
        if (element.classList.contains('secondary-element')) {
          element.parentNode.removeChild(element);
        }
      });
      toggle.textContent = showMore;
    }

    toggle.addEventListener('click', function () {
      toggle.toggleAttribute('aria-expanded');
      toggle.textContent.includes(showMore) ? show() : hide();
    });
    if (secondaryElementChildren && [...secondaryElementChildren].length > 0) {
      toggle.classList.add('block');
    } else {
      toggle.classList.add('hidden');
    }
  }
}

const showMore = {
  init: () => {
    document
      .querySelectorAll('.container-show-more-items')
      .forEach((element) => Toggle(element as HTMLElement));
  },
};

export default showMore;
